const {findOptionalArgument} = require("../util/ParserHelpers");
const {getOptimalLineWidth} = require("../../util/CanvasUtil");
const Font = require("../../util/Font");
const ColorUtil = require("../../util/ColorUtil");
const diagramColors = ColorUtil.getDiagramColors();

const makeParser = function(settings = {}) {
	return function(ps) {
		const symbol = settings.symbol || null;
		const defaultColor = {X: "teal", O: "red"}[symbol];
		const optArg1 = findOptionalArgument(ps);
		const color = optArg1 ? optArg1.getRest() : defaultColor;
		const validColors = [
			"red",
			"orange",
			"yellow",
			"green",
			"teal",
			"blue",
			"royalblue",
			"purple",
			"pink",
		];
		if (!validColors.includes(color)) {
			ps.pushError(
				`"${color}" is not a valid color. Must be one of ${validColors
					.map(c => `"${c}"`)
					.join(", ")}`
			);
			return false;
		}
		const scaleFactor = 1;
		return [
			{
				type: "drawnSymbol",
				symbol,
				color,
				scale: scaleFactor,
				children: [],
				...settings,
			},
		];
	};
};

// Draws a symbol at a given location and size
// Possible symbols: 'X', 'O'
// See also drawX, which crosses through an arbitrary rectangle.
const drawSymbol = function(ctx, letter, p, size, props = {}) {
	ctx.save();
	ctx.lineCap = "butt";
	ctx.lineJoin = "round";
	ctx.lineWidth = props.lineWidth || getOptimalLineWidth(ctx);
	const color = props.color || null;
	const inset = props.inset || 0.18 * size;
	const x = p[0] + inset;
	const y = p[1] + inset;
	const s = size - 2 * inset;
	const w = s;
	const h = s;
	const cx = x + w / 2;
	const cy = y + h / 2;
	switch (letter) {
		case "O":
			ctx
				.bp()
				.arc(cx, cy, s / 2, 0, 2 * Math.PI)
				.stroke(color);
			break;
		case "X":
			ctx
				.bp()
				.M(x, y)
				.L(x + w, y + h)
				.M(x + w, y)
				.L(x, y + h)
				.stroke(color);
			break;
		default:
			break;
	}
	ctx.restore();
};

const drawX = function(ctx, x, y, cellSize, color) {
	drawSymbol(ctx, "X", [x, y], cellSize, {
		color,
		lineWidth: 3 * getOptimalLineWidth(ctx),
	});
};

const drawO = function(ctx, x, y, cellSize, color) {
	drawSymbol(ctx, "O", [x, y], cellSize, {
		color,
		lineWidth: 3 * getOptimalLineWidth(ctx),
	});
};

const drawnSymbolNodeType = {
	draw(rc, x, y, node, measure) {
		const symbolMap = {X: drawX, O: drawO};
		const {cellSize, fontInfo} = measure;
		const drawFunc = symbolMap[node.symbol];
		if (drawFunc) {
			rc.context.save();
			rc.context.font = Font.fromInfo(fontInfo);
			drawFunc(
				rc.context,
				x,
				y - cellSize / 2,
				cellSize,
				diagramColors[node.color]
			);
			rc.context.restore();
		}
	},
	measure(rc, fontInfo, props, node) {
		const fontSize = fontInfo.size;
		const cellSize = fontSize * 1.15;
		return {
			width: cellSize * node.scale,
			top: (cellSize * node.scale) / 2,
			bottom: (cellSize * node.scale) / 2,
			fontInfo,
			cellSize,
		};
	},
	readAloud: node => node.symbol,
};

module.exports = {
	parsers: {
		mathCommands: {
			X: makeParser({symbol: "X"}),
			O: makeParser({symbol: "O"}),
		},
	},
	nodes: {
		drawnSymbol: drawnSymbolNodeType,
	},
};
